<template>
  <div>
    <base-header class="pb-6  bg-gradient-info">
    <div style="min-height:30px;"></div>
    
    
      <div v-if="0" class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Default</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>
        </div>
      </div>
      
      
      
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--6">
 

      <!--start new row-->
      
      <div class="row" style="margin-top:50px;">
     	<div class="col-xl-12">
     		 <div class="card">

		<div class="row" style="margin-top:20px;">
			<div  v-for="folder in folders" class="col-xl-3" @click="viewFolder(folder.id)" :key="folder.id">
				<div style="padding:20px;padding-bottom:70px;">
				<div style="float:left;cursor:pointer;"><i class="ni ni-folder-17 text-blue" style="font-size:32px;"></i></div>
				<div style="float: left;font-size: 13px;margin-left: 10px;margin-top: 7px;cursor:pointer;">{{folder.folder_name}}</div>
				</div>
			</div>	
			
			
		</div>
		<!-- end inner row -->

        
    </div>
		</div>
	 </div>


    
    </div>  <!--End container-->
    
    
    <div style="min-height:200px;"></div>

  </div>
</template>
<script>

  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'
  import { Table, TableColumn, Tabs, TabPane,} from 'element-ui'
  
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';

  export default {
    components: {
  		 [Table.name]: Table,
     	 [TableColumn.name]: TableColumn,
    },
    data() {
      return {
     	 folders:[],
	
      };
    },
    methods: {
       viewFolder(fid){
      			this.$router.push( '/view-folder/'+ fid);
        },
    },
    mounted() {
       swal.showLoading();
      
 		const client_info = JSON.parse(TokenService.getUserInfo());
      	let uri = this.$base_url+'/api/v1/c/get_e_folders/'+ client_info.entity_id;
         ApiService.get(uri).then(response => {
         	
      		 const vm = this;
      		 this.folders = response.data.folders;
   			 swal.close();
      	})
      	
      	
    }
  };
</script>
<style lang="scss">
@media screen and (max-width: 820px) {
	.ec_company_header_mob{
		display:none;
	}	
}



</style>














